import { ErrorBoundary } from '#app/components/ErrorBoundary/ErrorBoundary.js';
import { ErrorBoundaryContent } from '#app/components/ErrorBoundary/ErrorBoundaryContent.js';
import errorPageBackgroundImage from './assets/error-background.webp';
import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

const ErrorPage = styled.div`
  ${({ theme }) => css`
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;

    background-image: url(${errorPageBackgroundImage});
    background-repeat: no-repeat;
    background-position: bottom -100px right -100px;
    background-size: cover;

    ${theme.mediaQueries.md} {
      background-position: bottom right;
    }

    section {
      padding-bottom: 50%;

      ${theme.mediaQueries.md} {
        padding-bottom: 25%;
      }
    }
  `}
`;

type AppErrorBoundaryProps = {
  readonly children: ReactNode;
};

export const AppErrorBoundary = ({ children }: AppErrorBoundaryProps) => {
  return (
    <ErrorBoundary
      boundaryIdentifier="full-screen-app"
      renderError={({ report, reset, sentryEventId }) => (
        <ErrorPage>
          <ErrorBoundaryContent
            onReset={reset}
            onSendMessage={report}
            sentryEventId={sentryEventId}
          />
        </ErrorPage>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
